<template>
  <el-popover placement="left" trigger="click" @show="badgeHidden = true">
    <div class="image-lazy">
      <scrollbar type="thin">
        <template #scrollbar>
          <div v-for="(r, i) in radPics" :key="r.id" style="margin: 5px 0">
            <span style="margin-bottom: 5px">{{ formatTimestamp(r.beginTime) || i + 1 }}</span>
            <el-image
              :src="previewSrcList[i]"
              :lazy="i > 0"
              fit="contain"
              :preview-src-list="previewSrcList"
            ></el-image>
          </div>
        </template>
      </scrollbar>
    </div>
    <el-badge is-dot :hidden="badgeHidden" slot="reference" style="cursor: pointer">
      {{ '照片' | translateTo }}
    </el-badge>
  </el-popover>
</template>

<script>
import { getGcameraList } from '@/api/gcamera';
import { getToken, formatTimestamp } from '@/utils/utils';

export default {
  name: 'GcameraList',
  props: {
    radPicId: Object
  },
  data() {
    return {
      badgeHidden: true,
      radPics: []
    };
  },
  computed: {
    previewSrcList() {
      return this.radPics.map(
        r => `/access/devicedata/gcameraPic?pictureId=${r.id}&token=${getToken()}`
      );
    }
  },
  methods: {
    formatTimestamp
  },
  mounted() {
    getGcameraList({ sn: this.$route.params.sn }).then(res => {
      this.radPics = res.data;
    });
  },
  watch: {
    radPicInfo: {
      handler(newVal) {
        this.badgeHidden = false;
        this.radPics.unshift(newVal);
        if (this.radPics.length > 10) {
          this.radPics.pop();
        }
      },
      immediate: false,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.image-lazy {
  width: 400px;
  height: 170px;
  .el-image {
    width: 100%;
  }
}
</style>
